export enum TextToSpeechLanguageEnum {
  da = 'da',
  en = 'en',
  de = 'de',
  fr = 'fr',
}
